import * as React from 'react';
import { Box } from '@mui/material';
import { useCurrentDossierCtx, useDossierCustomHeader } from '@europrocurement/l2d-modules';
import { useFullLayout } from '@europrocurement/flexy-components';
import DetailDossierLeftNavBar from '../DetailDossierLeftNavBar/DetailDossierLeftNavBar';
import DossierBody from '../DossierBody/DossierBody';

const DetailDossierContainer: React.FunctionComponent = function () {
    const { setProfileHeaderVisible, setPageTitle, clearPageTitle } = useFullLayout();
    const { dossier } = useCurrentDossierCtx();
    const { setIsDossierDetailPath, setHeaderTitle } = useDossierCustomHeader();

    // Update custom Header data, the actions will be set in the DetailDossierLeftNavBar
    React.useEffect(() => {
        if (dossier) {
            setIsDossierDetailPath(true);
            setProfileHeaderVisible(false);
            setPageTitle(`Dossier #${dossier?.numero} | ${dossier?.clientOpereLibelle || ''}`);
            setHeaderTitle(`Dossier #${dossier?.numero} : ${dossier?.clientOpereLibelle || ''}`);
        }
        return () => {
            setIsDossierDetailPath(false);
            setProfileHeaderVisible(true);
            clearPageTitle();
        };
    }, [
        dossier,
        dossier?.numero,
        setHeaderTitle,
        setIsDossierDetailPath,
        setProfileHeaderVisible,
        setPageTitle,
        clearPageTitle,
        dossier?.clientOpereLibelle,
    ]);

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
            }}
        >
            <Box
                sx={{
                    width: '25%',
                    height: '100%',
                    position: 'sticky',
                    top: '24px',
                    left: 0,
                    mr: 2,
                }}
            >
                <DetailDossierLeftNavBar sx={{ width: '100%' }} />
            </Box>

            <Box sx={{ flex: 1, height: '100%', paddingLeft: '8px', minWidth: 0 }}>
                <DossierBody />
            </Box>
        </Box>
    );
};

export default DetailDossierContainer;
